import Strings from "../assets/strings";
import {IKeyValue} from "../redux/types/Icommon";
import _ from "lodash";


export const ESTADO_INTERCAMBIO = {
    pendiente: 1,
    aprobada: 2,
    rechazada: 3,
    inactiva: 4,
};
export const ESTADO_COMPRA = {
    pendiente: 1,
    aprobada: 2,
    rechazada: 3,
    inactiva: 4,
};
export const ESTADO_CANJE= {
    pendiente: 1,
    aprobada: 2,
    rechazada: 3,
    inactiva: 4,
};
export const PERSMISOS = {
    settings:1,

    notificaciones:3,
    enviarCorreo:4,


    purchases: 10,
    purchasesUpdate:11,
    purchasesCreate: 12,
    purchasesDelete:13,
    purchasesChangeStatus:14,
    purchasesExport:15,
    purchasesRemoveApproval:16,

    pharmacies: 20,
    pharmaciesUpdate: 21,
    pharmaciesCreate: 22,
    pharmaciesDelete: 23,
    pharmaciesChangeStatus: 24,
    pharmaciesExport: 25,

    pharmaciesGenerateUser: 26,
    pharmaciesViewUser: 27,




    patients: 30,
    patientsDelete: 31,
    patientsUpdate: 32,
    patientsCreate: 33,
    patientsChangeStatus: 34,
    patientsPrescriptionAdd: 35,
    patientsPrescriptionDelete: 36,
    patientsExport: 37,



    exchanges: 40,
    exchangesDelete: 41,
    exchangesUpdate: 42,
    exchangesCreate: 43,
    exchangesChangeStatus: 44,
    exchangesExport: 45,
    exchangesRemoveApproval: 46,

    users: 50,
    usersUpdate: 51,
    usersCreate: 52,
    usersDelete: 53,
    usersBlock: 54,
    usersChangePassword: 55,

    roles: 60,
    rolesUpdate: 61,
    rolesCreate: 62,
    rolesDelete: 63,


    medicalSpecialities: 70,
    medicalSpecialitiesCreate: 71,
    medicalSpecialitiesUpdate: 72,
    medicalSpecialitiesDelete: 73,

    product: 80,
    productsCreate: 81,
    productsUpdate: 82,
    productsDelete: 83,
    productsExport: 84, //se elimino

    productCategories: 90,
    productCategoriesCreate: 91,
    productCategoriesUpdate: 92,
    productCategoriesDelete: 93,


    policyExchanges: 100,
    policyExchangesCreate: 101,
    policyExchangesUpdate: 102,
    policyExchangesDelete: 103,









};
export const PERSMISOS_USUARIOS = {
    webApp:500,
    cilosPago:501,
    documentos:502,
    geoMapa:503,
    cajas:504,
    rutas:505,
    gastos:506,
    carteras:507,
    solicitudes:508,
    plantillas:509,
    garantias:510,
    alquilerInmueble:5011
}
export const MODULO_USUARIO = {
    webApp:1,
    cilosPago:2,
    documentos:3,
    geoMapa:4,
    cajas:5,
    rutas:6,
    gastos:7,
    carteras:8,
    solicitudes:9,
    plantillas:10,
    garantias:11,
    alquilerInmueble:12,
    agentes:13,
    pagoRapido:14,
    ocultarPieRecibo:15,
    ocultarPieEstadoCuenta:16,
    whatsappBot: 17,
    enviarCorreo: 18,
    ingresos:19
}

export const TIPO_USUARIO = {
    sistema: 1,
    paciente: 2,
    farmacia: 3,
}
export const TIPOPLAN = {
    gratis: 1,
    basico: 2,
    profesional: 3,
    avanzado: 4,
    basicoPro: 5,
    personal: 6,
    ilimitado: 7,
    comercial: 8,
    empresarial: 9,
}



export const TIPOPAGO={
    // PAGO_RAPIDO:9,
    CUOTA_COMPLETA: 1,
    // PAGO_PARCIAL: 2,
    ABONO_CAPITAL: 3,

    AUSTE_CAPITAL: 4,
    SOLO_INTERES: 5,
   // PAGO_MORA:7,

    SALDAR:6,
    PAGO_BORRADOR:8,
    PAGO_INICIAL:10
};


export const TIPO_NOTIFICACION={
     SOLICITUD: 1,
     PAGO_CLIENTE: 2,
     NOTA_PRESTAMO: 3,
     MENSAJE_SISTEMA: 4,
     NUEVO_USUARIO: 5,
     OTROS: 99

};

export const getValueString = (constant:any = {},value?:number, trans= true) =>{
    let prop = "";
    if (value !== undefined && Object.keys(constant)?.length) {
        Object.keys(constant).forEach((pro)=>{
            if(constant[pro] === value){
                prop = trans ? ((Strings as any)[_.camelCase(pro)] || _.startCase(_.toLower(pro))) : pro;
            }
        })
    }
    return prop;
}
export const objToKeyValue = (constant:any = {}) =>{
    let arr:IKeyValue[] = [];
    Object.keys(constant).forEach((pro,i)=>{
        arr.push({
            key:constant[pro],
            value:(Strings as any)[_.camelCase(pro)] || _.startCase(_.toLower(pro))
        })
    })
    return arr;
}



